import { Link } from "react-router-dom";
const Footer = () => {
    return (
        <div className="fondo">
            <div className="container pt-5">
            <div className="row text-center">
            <div className="col-3 text-center">
                    <Link to="https://www.marthadebayle.com/" target="_blank"><img className="iconFooter mt-2" src={process.env.PUBLIC_URL + "/image/Logos/LOGO-MD.png"} /></Link>
                </div>
                <div className="col-3">
                    <Link to="https://www.mmkgroup.com.mx/" target="_blank"><img className="iconFooter" src={process.env.PUBLIC_URL + "/image/Logos/LOGO-MMK.png"} /></Link>
                </div>
                <div className="col-3 text-center">
                    <Link to="https://www.bbmundo.com/" target="_blank"> <img className="iconFooter mt-2" src={process.env.PUBLIC_URL + "/image/Logos/LOGO-BB.png"} /></Link>
                </div>
                <div className="col-3 text-center">
                    <Link to="https://www.revistamoi.com/" target="_blank"><img className="iconFooter mt-2" src={process.env.PUBLIC_URL + "/image/Logos/LOGO-MOI.png"} /></Link>
                </div>
                <div className="col-12 mt-4">
                    <h5 className="titulosArbolitos mb-4">#ARBOLITOSDEBAYLE</h5>
                    <p className="titulosMons">ALEJANDRO DUMAS 241 / COL. POLANCO REFORMA / CP 11550 / MÉXICO CDMX / TELÉFONO 9126 2222</p>
                </div>
                <div className="col-sm-12 text-center mt-2">
                    <p className="letrasFooter">© Todos los Derechos Reservados de Media Marketing Knowledge Group www.mmkgroup.com.mx Prohibida la reproducción total o parcial, incluyendo cualquier medio electrónico o magnético.</p>
                </div>
                <div className="col-12 pb-2">
                    <Link className="letrasFooter" to="https://www.marthadebayle.com/v3/sin-categoria/politica-de-privacidad/">Politica de Privacidad</Link>
                </div>
            </div>
        </div>
        </div>
    )
}
export default Footer;